/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ServiceAdminUserUpdateMutationVariables = Types.Exact<{
  input: Types.ServiceAdminUserUpdateInput;
}>;


export type ServiceAdminUserUpdateMutation = { __typename: 'Mutation', serviceAdminUserUpdate: { __typename: 'User', id: string, email: string, roles: Array<Types.Role> } };


export const ServiceAdminUserUpdateDocument = gql`
    mutation ServiceAdminUserUpdate($input: ServiceAdminUserUpdateInput!) {
  serviceAdminUserUpdate(input: $input) {
    id
    email
    roles
  }
}
    `;
export type ServiceAdminUserUpdateMutationFn = ApolloReactCommon.MutationFunction<ServiceAdminUserUpdateMutation, ServiceAdminUserUpdateMutationVariables>;

/**
 * __useServiceAdminUserUpdateMutation__
 *
 * To run a mutation, you first call `useServiceAdminUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useServiceAdminUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [serviceAdminUserUpdateMutation, { data, loading, error }] = useServiceAdminUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServiceAdminUserUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ServiceAdminUserUpdateMutation, ServiceAdminUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ServiceAdminUserUpdateMutation, ServiceAdminUserUpdateMutationVariables>(ServiceAdminUserUpdateDocument, options);
      }
export type ServiceAdminUserUpdateMutationHookResult = ReturnType<typeof useServiceAdminUserUpdateMutation>;
export type ServiceAdminUserUpdateMutationResult = ApolloReactCommon.MutationResult<ServiceAdminUserUpdateMutation>;
export type ServiceAdminUserUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ServiceAdminUserUpdateMutation, ServiceAdminUserUpdateMutationVariables>;